const { mockAlpheraProposal } = require('./mock-alphera-proposal');
const { mockBnpProposal } = require('./mock-bnp-proposal');
const { mockCloseProposal } = require('./mock-close-proposal');
const { mockZopaProposal } = require('./mock-zopa-proposal');
const { mockHpProposal } = require('./mock-hp-proposal');
const { mockMotonovoProposal } = require('./mock-motonovo-proposal');

module.exports = {
    mockAlpheraProposal,
    mockBnpProposal,
    mockCloseProposal,
    mockZopaProposal,
    mockHpProposal,
    mockMotonovoProposal
}